import React from "react";
import Navbar from "../components/nav/Nav";
import Footer from "../components/nav/Footer";
import Benefits from "../components/landingpage/Benefits";
import Services from "../components/landingpage/Services";
import Description from "../components/landingpage/Description";

import Hero from "../components/landingpage/Hero";
import Seo from "../components/SEO/SEO";
import ProcessDescription from "../components/landingpage/ProcessDescription";
import { useMatomo } from "@datapunt/matomo-tracker-react";
import styles from "../index.css";
import { getPrices } from "../api";

function Index() {
  const { trackPageView } = useMatomo();

  React.useEffect(() => {
    trackPageView();
  }, []);

  React.useEffect(() => {
    getPrices();
  });
  return (
    <>
      <Seo />
      <Navbar />
      <Hero />
      <Benefits />
      <Services />
      <ProcessDescription />
      <Description />
      <Footer />
    </>
  );
}

export default Index;
